import { BillSearchModel } from '@app/data-layer/models/payments';

export class OffsetChange {
  public static readonly type = '[User Billing] Offset Change';

  constructor(public payload: number) {}
}

export class UpdateLoadingState {
  public static readonly type = '[User Billing] Update Loading State';

  constructor(public payload: boolean) {}
}

export class ResetBillListData {
  public static readonly type = '[User Billing] Reset BillList Data';
}

export class FetchBillList {
  public static readonly type = '[User Billing] Fetch BillList Quotes';

  constructor(public payload: { filters: BillSearchModel; companyId?: number; offset?: number; limit?: number }) {}
}

export class SetDefaultPaginationState {
  public static readonly type = '[User Billing] Set Default Pagination State';
}
